/**
 * Shared Motion (motion/react) variants for Gulf TechLab.
 * RTL-aware: pass `dir` ("ltr" | "rtl") from LanguageContext so slide
 * directions flip correctly for Arabic. Respects prefers-reduced-motion
 * by collapsing every transform to an instant, opacity-only fade.
 */

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

const EASE_OUT = [0.22, 1, 0.36, 1];

export const pageVariants = (dir = "ltr") => {
  const reduced = prefersReducedMotion();
  const xOffset = dir === "rtl" ? -24 : 24;
  return {
    initial: { opacity: 0, x: reduced ? 0 : xOffset },
    animate: { opacity: 1, x: 0, transition: { duration: reduced ? 0.01 : 0.45, ease: EASE_OUT } },
    exit: { opacity: 0, x: reduced ? 0 : -xOffset, transition: { duration: reduced ? 0.01 : 0.3, ease: EASE_OUT } },
  };
};

export const staggerContainer = (staggerMs = 80) => ({
  hidden: {},
  show: {
    transition: { staggerChildren: prefersReducedMotion() ? 0 : staggerMs / 1000 },
  },
});

export const staggerItem = {
  hidden: { opacity: 0, y: prefersReducedMotion() ? 0 : 16 },
  show: { opacity: 1, y: 0, transition: { duration: prefersReducedMotion() ? 0.01 : 0.5, ease: EASE_OUT } },
};

export const hoverLift = prefersReducedMotion()
  ? {}
  : { whileHover: { y: -4, transition: { duration: 0.2, ease: EASE_OUT } }, whileTap: { scale: 0.98 } };

export const pressScale = prefersReducedMotion()
  ? {}
  : { whileHover: { scale: 1.02 }, whileTap: { scale: 0.96 } };

export const wordRevealContainer = (staggerMs = 90) => ({
  hidden: {},
  show: {
    transition: { staggerChildren: prefersReducedMotion() ? 0 : staggerMs / 1000, delayChildren: prefersReducedMotion() ? 0 : 0.15 },
  },
});

export const wordRevealItem = {
  hidden: { opacity: 0, y: prefersReducedMotion() ? 0 : 40, filter: prefersReducedMotion() ? "none" : "blur(14px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: prefersReducedMotion() ? 0.01 : 0.8, ease: EASE_OUT },
  },
};
